export default "__VITE_ASSET__CL6g2ZJ7__"